module.exports = __webpack_public_path__ + "media/images/admin/icons/bold-b04d18b95c3a94680dc5e2b8ec900be4.svg";